// TODO: Note: this Util is created to generate a unique ID to make sure in this case an input checkbox an unique value. task:'https://app.asana.com/0/1206535132181770/1207555590485734/f'

export const uniqueId = (prefix = 'id'): string => `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
